export const NOTE_VISIBILITY_EVERYONE = 5
export const NOTE_VISIBILITY_STAFF = 10
export const NOTE_VISIBILITY_AUTHOR_ONLY = 20
export const NOTE_VISIBILITY_LEVELS = {
  everyone: NOTE_VISIBILITY_EVERYONE,
  staff: NOTE_VISIBILITY_STAFF,
  author: NOTE_VISIBILITY_AUTHOR_ONLY
}
